import { Link, useLocation } from "react-router-dom";

/**
 * Phase 9.7.5 — Global compliance footer.
 *
 * Surfaces the legal + compliance pages required for trust, app-store
 * readiness, and creator monetization legitimacy:
 * - Privacy Policy
 * - Terms of Service
 * - Community Guidelines
 * - Copyright / DMCA
 * - Creator Monetization Policy
 * - Refund Policy
 * - Payout Policy
 *
 * Hidden on routes where the footer would conflict with full-bleed UX
 * (Live Room, Auth callback, etc.) — see `HIDDEN_PATHS`.
 */
const HIDDEN_PATHS = [
  /^\/beams\/[^/]+$/, // inside live room
  /^\/live\/[^/]+$/,
  /^\/auth\/callback/,
];

const FOOTER_LINKS = [
  { to: "/support", label: "🎧 Support & Feedback", testid: "footer-support" },
  { to: "/privacy", label: "Privacy Policy", testid: "footer-privacy" },
  { to: "/terms", label: "Terms of Service", testid: "footer-terms" },
  { to: "/community-guidelines", label: "Community Guidelines", testid: "footer-guidelines" },
  { to: "/dmca", label: "Copyright / DMCA", testid: "footer-dmca" },
  { to: "/monetization-policy", label: "Monetization Policy", testid: "footer-monetization" },
  { to: "/refund-policy", label: "Refund Policy", testid: "footer-refund" },
  { to: "/payout-policy", label: "Payout Policy", testid: "footer-payout" },
  { to: "/delete-account", label: "Delete Account", testid: "footer-delete-account" },
];

const GlobalFooter = () => {
  const location = useLocation();
  if (HIDDEN_PATHS.some((re) => re.test(location.pathname))) return null;

  return (
    <footer
      data-testid="global-footer"
      className="mt-12 border-t border-white/5 bg-[#06060a] py-8 px-4 sm:px-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="text-sm text-pink-200/70">
          © {new Date().getFullYear()} RGM Studio · Real Global Music Entertainment
        </div>
        <nav className="flex flex-wrap gap-x-4 gap-y-2 text-xs">
          {FOOTER_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className="text-pink-200/60 hover:text-amber-200 transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <a
            href="mailto:realglobalmusicent@yahoo.com"
            data-testid="footer-contact"
            className="text-pink-200/60 hover:text-amber-200 transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default GlobalFooter;
